import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2988697c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "floating" }
const _hoisted_2 = { class: "floating-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-text" }, "扫码下载游戏", -1))
const _hoisted_4 = { class: "qrcode" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "icon-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["src"]

import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/PcComponents/Modal/index.vue";
import { GlobalState } from "@/pages/index/store";
import { getGameCommunity, buriedPoint } from "@/api/indexPC";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  async setup(__props) {

let __temp: any, __restore: any

const store = useStore<GlobalState>();

onMounted(() => {
  window.addEventListener("scroll", () => {
    let scrollY = document.documentElement.scrollTop || document.body.scrollTop;
    // 700
  });
});
function test(v) {
  console.log(v);
}
function gotoTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

let result = (
  ([__temp,__restore] = _withAsyncContext(() => getGameCommunity())),
  __temp = await __temp,
  __restore(),
  __temp
);
let gameCommunityList = ref<any[]>(result.data);
let temp = gameCommunityList.value[2];
gameCommunityList.value[2] = gameCommunityList.value[3];
gameCommunityList.value[3] = temp;
let iconList = [
  require("@/assets/img/index/icon-weibo.png"),
  require("@/assets/img/index/icon-wechat.png"),
  require("@/assets/img/index/icon-qq.png"),
  require("@/assets/img/index/icon-douyin.png"),
  require("@/assets/img/index/icon-redbook.png"),
];
let isShow = ref(false);
let qrcode = ref("");
/**
 *
 * @param obj PC弹出方式[1-弹出二维码,2-显示QQ群,3-跳转链接]
 */
function gotoCommunity(obj: any) {
  // 埋点
  buriedPoint(obj.name, 1);
  if (obj.way === 1) {
    // 弹出二维码
    isShow.value = true;
    qrcode.value = obj?.code;
  }
  if (obj.way === 3) {
    // 跳转链接
    window.open(obj.url);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _unref(store).state.prosperityObj.code,
          alt: "公众号"
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameCommunityList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item?.id,
            onClick: ($event: any) => (
            gotoCommunity({
              way: item?.way,
              url: item?.url,
              code: item?.code,
              qq: item?.qq,
              name: item?.name,
            })
          )
          }, [
            _createElementVNode("img", {
              src: _unref(iconList)[index],
              alt: item.name
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: "floating-bottom",
      onClick: gotoTop
    }),
    _createVNode(Modal, {
      show: _unref(isShow),
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isShow) //@ts-ignore
 ? isShow.value = false : isShow = false))
    }, {
      qrcode: _withCtx(() => [
        _createElementVNode("img", { src: _unref(qrcode) }, null, 8, _hoisted_9)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})